import { Events } from '@atlassian/mpac-telemetry';
const createListener = _ref => {
  let {
    onRouteTransitionEnd
  } = _ref;
  return event => {
    switch (event.type) {
      case Events.LABEL_PAGE_VIEW_TASK:
        if (onRouteTransitionEnd) {
          onRouteTransitionEnd();
        }
        break;
    }
  };
};
export default createListener;